import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://emdlfhtbfpdzhowvzssr.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseAnonKey) {
  console.error('❌ ERROR: REACT_APP_SUPABASE_ANON_KEY is required. Please set it in your .env file.');
  throw new Error('Supabase anon key is required. Set REACT_APP_SUPABASE_ANON_KEY in your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
